import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'geometry-manager',
    templateUrl: './geometry-manager.component.html',
    styleUrls: ['./geometry-manager.component.scss'],
    standalone: false
})
export class GeometryManagerComponent {
    config_: any;

    @Input()
    set config(val: any) {
        this.config_ = val;

        if (this.config_ && !this.config_.geometry)
            this.config_.geometry = {
                layers: []
            }
    }

    get layers() {
        return this.config_.geometry.layers;
    }

    addLayer() {
        this.layers.push({
            title: `Layer #${this.layers.length + 1}`
        });
    }

    delete(layer) {
        let idx = this.layers.findIndex(x => x === layer);

        if (idx != -1)
            this.layers.splice(idx, 1);
    }
}
